'use client'
import { FormField, FormDatePickerProps } from '../../../FormElements'
import { ComponentTranslationContext } from '../../../../providers'
import { FilterOperator } from '../../../../types/Filters'
import React, { useContext } from 'react'
import { DateFilter } from './DateFilter'
import { MESSAGE_KEYS } from '../../../../constants/messageKeys'

export interface FromToDateFilterProps extends Omit<FormDatePickerProps, 'value' | 'name' | 'id' | 'onChange'> {
    /** "name" of object that should be filtered on. Will be used to create unique ID for "Filter" Object. This should be exactly the key that the API needs to filter on */
    name: string
    label: string
}

export const FromToDateFilter = ({ label, name, ...props }: FromToDateFilterProps): JSX.Element => {
    const { getLabel } = useContext(ComponentTranslationContext)
    const fromFieldName = `date-filter_${name}[${FilterOperator.GREATER_THAN_OR_EQUAL}]`
    const toFieldName = `date-filter_${name}[${FilterOperator.LESSER_THAN_OR_EQUAL}]`

    return (
        <FormField label={label} name={fromFieldName}>
            <div className="inline-flex items-center gap-2">
                <DateFilter
                    {...props}
                    label={label}
                    name={name}
                    operator={FilterOperator.GREATER_THAN_OR_EQUAL}
                    fieldName={fromFieldName}
                />
                {getLabel(MESSAGE_KEYS.TO)}
                <DateFilter
                    {...props}
                    label={label}
                    name={name}
                    operator={FilterOperator.LESSER_THAN_OR_EQUAL}
                    fieldName={toFieldName}
                />
            </div>
        </FormField>
    )
}
